import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { makeAPIRequestReactQuery } from '@/react-query/api';

export const useHasWriteback = (enabled: boolean) => {
  const {
    primaryPracticeId: currentPracticeId,
    primaryOrganizationId: currentOrganizationId,
  } = useSelector((state: any) => state.login.user);

  return useQuery({
    queryKey: [
      'videa-notes-writeback',
      currentOrganizationId,
      currentPracticeId,
    ],
    queryFn: async () => {
      const data = await makeAPIRequestReactQuery<{
        hasWritebackSupport: boolean;
      }>('/videa-notes/writeback', {}, 'get', {
        headers: {
          'Access-Control-Allow-Origin': '*',
          practice: currentPracticeId,
          org: currentOrganizationId,
        },
      });
      return data.hasWritebackSupport;
    },
    enabled: !!currentPracticeId && !!currentOrganizationId && enabled,
  });
};
